<template>
  <div class="pt-10">
    <div class="row">
      <div class="col-11 mt-5 pt-5 ml-2 text-left">
        <h5 class="text-danger">
          <i @click="back()" class="fa fa-arrow-left text-success m-0 p-0" style="cursor: pointer;" aria-hidden="true"></i>&nbsp;<strong>REGRESAR AL LISTADO DE PROMOCIONES</strong>
        </h5>
      </div>
    </div>

    <!-- Lista de usuarios beneficiarios de la promoción -->
    <div class="row mt-4">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-striped table-sm">
            <caption class="visually-hidden">Listado de Promociones</caption>
            <thead>
              <tr>
                <th scope="col" style="text-align: left">Nombre Usuario</th>
                <th scope="col" style="text-align: left">Número de documento</th>
                <th scope="col" style="text-align: left">Correo</th>
                <th scope="col" style="text-align: left">Promoción</th>
                <th scope="col" style="text-align: left">Fecha inscripción</th>
                <th scope="col" style="text-align: left">Puntos obtenidos</th>
                <th scope="col" style="text-align: left">Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in items.slice((currentPage - 1) * pageSize, currentPage * pageSize)" :key="item.id">
                <td v-if="item.users.last_name != null" style="text-align: left">
                  {{ item.users.name }} {{ item.users.last_name }} 
                </td>
                <td v-else style="text-align: left">
                  {{ item.users.name }}
                </td>
                <td style="text-align: left">
                  {{ item.users.document_number }}
                </td>
                <td style="text-align: left">
                  {{ item.users.email }}
                </td>
                <td style="text-align: left">
                  {{ item.promotions.name_promotion }}
                </td>
                <td style="text-align: left">
                  {{ item.created_at }}
                </td>
                <td style="text-align: left">
                  <h5>
                    <span class="badge badge-pill badge-danger">
                      {{ item.promotions.points }}
                    </span>
                  </h5>
                </td>
                <td style="text-align: left">
                  <h5>
                    <span class="badge badge-pill badge-success">
                    {{ item.status.name }}
                    </span>
                  </h5>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Paginación -->
    <div style="margin:25px 5px 5px 5px;" class="d-flex justify-content-center">
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item" :class="{disabled: currentPage === 1}">
            <a class="previous page-link" href="#" @click.prevent="prevPage()">
              <
            </a>
          </li>
          <li class="page-item" v-for="page in pages" :key="page" :class="{active: currentPage === page}">
            <a class="page-link" href="#" @click.prevent="changePage(page)">
              {{ page }}
            </a>
          </li>
          <li class="page-item" :class="{disabled: currentPage === totalPages}">
            <a class="next page-link" href="#" @click.prevent="nextPage()">
              >
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <!-- Fin de la lista de usuarios beneficiarios de la promoción -->
  </div>
</template>

<script>
// import $ from "jquery";
import vPagination from "vue-plain-pagination";
import axios from 'axios';

export default {
  components: { vPagination },
  data() {
    return {
      items: [],

      // Paginación
      currentPage: 1,
      pageSize: 10,
      totalDatos: 0,
      totalPages: 0,
      paginatedData: [],
      paginationVisible: true,

      loading: {
        history: false,
      },
    };
  },
  computed: {
    pages() {
      const pages = [];
      const limit = this.totalPages > 5 ? 5 : this.totalPages;
      let start = this.currentPage - 2;
      if (start <= 0) start = 1;
      let end = start + limit - 1;
      if (end > this.totalPages) {
        end = this.totalPages;
        start = end - limit + 1;
        if (start <= 0) start = 1;
      }
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  methods: {
    back(){
      this.$router.push({ name: "promotions" })
    },
    getList() {
      this.loading.history = true;
      var id = this.$route.params.id;
      axios
        .get("admin/list-users/" + id)
        .then((res) => {
          this.loading.history = false;
          if (res.data.cod == 0) {
            this.items = res.data.data;
            this.totalDatos = this.items.length;
            this.totalPages = Math.ceil(this.totalDatos / this.pageSize);
            this.paginated();
          }
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },

    // Paginación
    paginated() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.paginatedData = this.items.slice(start, end);
    },
    changePage(page) {
      this.currentPage = page;
      this.paginated();
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.paginated();
      }
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.paginated();
      }
    },
    changeSize(size) {
      this.pageSize = size;
      this.totalPages = Math.ceil(this.totalDatos / this.pageSize);
      this.currentPage = 1;
      this.paginated();
    },
    // Fin paginación
  },
  mounted() {
    this.getList();
  },
};
</script>

<style>
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #dc3545;
  border-color: #dc3545;
}
.page-link {
  border-radius: 100px;
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #dc3545;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
.page-link:hover {
  color: #000;
}
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
</style>
